import { render, staticRenderFns } from "./Axis.vue?vue&type=template&id=141b86aa&"
import script from "./Axis.vue?vue&type=script&lang=js&"
export * from "./Axis.vue?vue&type=script&lang=js&"
import style0 from "./Axis.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Axis.vue"
export default component.exports